module.exports = __webpack_public_path__ + "static/img/4.26b8bc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/4.jpg
// module id = M63m
// module chunks = 1